import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { getError } from './utils';
import * as S from './styles';
import { ErrorPageBall, ErrorPageBeat, ErrorPageLogo } from '~/assets/images';

/** el caracter '@' será sustituído por el icono del balón */
const codes = {
  404: '4@4',
  403: '4@3',
  500: '5@5',
  oops: 'O@PS',
};

const ErrorPage = () => {
  const { t } = useTranslation();
  const { push } = useHistory();
  const code = window.localStorage.getItem('errorCode');
  const title = getError(code);
  const errorCode = code ? codes[code] : codes.oops;

  return (
    <S.ErrorPageContainer>
      <S.Beat src={ErrorPageBeat} alt="" />
      <S.Content>
        <S.Logo src={ErrorPageLogo} />
        <S.ErrorCode>
          {Array.from(errorCode).map(letter =>
            letter === '@' ? (
              <img key={Math.random()} src={ErrorPageBall} alt="" />
            ) : (
              <span key={Math.random()}>{letter}</span>
            )
          )}
        </S.ErrorCode>
        <S.Title>{title}</S.Title>
        <S.FlexContainer>
          <S.Button
            onClick={() => {
              window.localStorage.removeItem('redirectError');
              push({ pathname: '/' });
            }}
          >
            {t('backToHome')}
          </S.Button>
        </S.FlexContainer>
      </S.Content>
      <S.Beat src={ErrorPageBeat} alt="" reverse />
    </S.ErrorPageContainer>
  );
};

export default ErrorPage;
